import React, { Component } from 'react';
import Slider from "react-slick";
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css'; 

const lightBoxStyle = {
  content : {
   // zIndex:21000,
   // backgroundColor: 'red'

    
  }
};
class AiImageBig extends Component {
  constructor(props) {
    super(props);
    this.openLightBox = this.openLightBox.bind(this);
    this.closeLightBox = this.closeLightBox.bind(this);
    this.slider = React.createRef();
    this.state = {
      photoIndex: this.props.active_view - 1,
      cross: [this.props.cross1, this.props.cross2, this.props.cross3],
      lastviews: this.props.views
    };
  }
  componentDidUpdate(){
    /* if (this.slider.current)
    console.log(this.slider.current.innerSlider.state.currentSlide, this.props.active_view) */
    /* console.log('slickGoTo view', this.props.active_view,this.props.views)
    if (this.props.active_view > this.props.views)
      this.slider.current.slickGoTo(0)
    else
      this.slider.current.slickGoTo(this.props.active_view-1) */
    if (this.props.views !== this.state.lastviews) {
      //console.log(this.props.views, this.state.lastviews)
      this.setState({lastviews: this.props.views})
      if (this.props.views === this.props.max_views)
        this.slider.current.innerSlider.state.currentSlide = 0
      else if (this.props.active_view !== 1)
        this.slider.current.innerSlider.state.currentSlide = this.props.active_view-1
      else
        this.slider.current.innerSlider.state.currentSlide = this.props.views - 1
      //this.slider.current.slickGoTo(0)
    }
    else if (!this.props.pushOpenBox) // && this.props.active_view === 1)
      this.slider.current.slickGoTo(this.props.active_view - 1)
      //this.slider.current.slickGoTo(this.slider.current.innerSlider.state.currentSlide)
    /* else if (!this.props.pushOpenBox && this.slider.current.innerSlider.state.currentSlide !== this.props.active_view-1)
      this.slider.current.slickGoTo(this.props.active_view-1) */
  }

  openLightBox () {
    this.props.onOpenOpenBox(this.props.type) 
  } 

  closeLightBox () {
    this.props.onCloseOpenBox()
  } 
   
  render() {
    var splashScreen = (this.props.type === '0')
    //console.log('render IMAGE view=',this.props.slides)
    //var base_url = this.props.view_image_base;
    //var base_url = this.props.slides;
    var thumb_url = this.props.thumb;
    
    let sizeClass=this.props.size
    const settingsPortrait = {
      dots: false,
      //dotsClass: "slick-dots slick-thumb",
      infinite: false,
      initialSlide: this.props.active_view - 1, 
      className: 'ai-img-wrap-' +sizeClass,
      speed: 500,
      arrows:true,
      fade:true,
      lazyLoad:true,
      slidesToShow: 1,
      centerMode: false,
      slidesToScroll: 1,
      afterChange: (current) => {
        //console.log('ch view',current);
        if (current + 1 > this.props.max_views && this.props.views !== this.state.lastviews)
          this.props.onChange(current);
      }
      
    };
    const settingsLandscape = {
      //?v=${i+1}
      customPaging: function(i) {
          //let slide = this.props.slides[i]
          return (
          <a>
            <img className={'ai-img-thumbnail-'+sizeClass} src={`${thumb_url[i]}`}  alt='' draggable="false" onDragStart={(e) => { e.preventDefault() }}/> 
          </a>
        );
      },
      dots: true,
      dotsClass: 'slick-dots slick-dots-'+sizeClass + ' slick-thumb',
      infinite: false,
      initialSlide: this.props.active_view - 1, //this.slider.current ? this.slider.current.innerSlider.state.currentSlide : (this.props.active_view - 1),
      speed: 500,
      arrows:false,
      className: 'ai-img-wrap-'+sizeClass,
      fade:true,
      lazyLoad:true,
      slidesToShow: 1,
      centerMode: false,
      //centerPadding: "20px",
      slidesToScroll: 1,
      //afterChange: (current) => {/* this.props.onChange(current); */console.log('ch view',current+1,this.props.views);this.slider.current.slickGoTo(this.props.active_view-1)},
      //beforeChange: (current) => {/* if (this.props.views > (current+1)) {this.slider.current.slickGoTo(this.props.active_view-1)} */
      //  console.log('ch view',current+1,this.props.views);},
      //onReInit: (current) => {console.log('views', this.props.views); console.log('active view', this.props.active_view);console.log(this.slider.currentSlide)}
      //afterChange: (current) => {console.log('ch view',current);}
      afterChange: (current) => {
        //console.log(current, this.state.lastviews, this.props.views)
        if (current + 1 > this.props.max_views && this.props.views !== this.state.lastviews)
          this.props.onChange(current);
        }
      /* onReInit: (current) => {console.log(this.props.active_view);
        this.slider.current.slickGoTo(this.props.active_view-1)} */
      
    };
    let settings ={}
   
    if (this.props.orientation === 'portrait') {
      settings =settingsPortrait
    }
    else {
      settings =settingsLandscape
    }
   var { photoIndex } = this.state;
   if (this.slider.current)
    photoIndex = this.slider.current.innerSlider.state.currentSlide
   else
    photoIndex = this.props.active_view-1;
   var images = this.props.slides
   if (this.props.slides[0].includes('init') && this.props.orientation === 'portrait')
    images = [this.props.slides[0].replace('.jpg','p.jpg')]
   var imagesZoom=this.props.slidesZoom

   var imgrow2 = 'ai-image-big-wrap' + (this.props.views === 6 ? ' ai-image-row2' : '')

   return (
      <div className={imgrow2} >
        <Slider ref={this.slider}   {...settings} >
        {this.props.slides.map(slide =>
              // <div className={'ai-img-'+sizeClass}  key={slide}  >
                <img className={'ai-src-img-'+sizeClass}  
                key={slide}
                src={slide.includes('init') ? (this.props.orientation === 'portrait' ? this.props.slides[0].replace('.jpg','p.jpg') : slide) : slide} 
                onClick={this.openLightBox}
                alt=''
                draggable="false"
                onDragStart={(e) => { e.preventDefault() }}
                useMap={splashScreen ? ('#map-' + sizeClass) : ''} //{splashScreen ? (sizeClass !== 'medium' ? '#map-big' : '#map-small') : ''}
                />
              // </div>
          )}
      
      </Slider>   
      {( this.props.pushOpenBox ) && (
           <Lightbox
            mainSrc={imagesZoom[photoIndex]}
            nextSrc={imagesZoom[(photoIndex + 1) % images.length]}
            prevSrc={imagesZoom[(photoIndex + images.length - 1) % images.length]}
            onCloseRequest={this.closeLightBox}
            reactModalStyle={lightBoxStyle}
            /* onMovePrevRequest={() =>
              this.setState({
                photoIndex: (photoIndex + images.length - 1) % images.length,
              })
            } */
            enableZoom ={false}
            /* onMoveNextRequest={() =>
              this.setState({
                photoIndex: (photoIndex + 1) % images.length,
              })
            }   */
            /* onMovePrevRequest={() => this.props.onChange((photoIndex + images.length - 1) % images.length)}
            onMoveNextRequest={() => this.props.onChange((photoIndex + 1) % images.length)} */
            onMovePrevRequest={() => this.props.onChange(Math.max(0, photoIndex - 1))}
            onMoveNextRequest={() => this.props.onChange(Math.min(photoIndex + 1, images.length - 1))}
             onAfterOpen={() =>
               this.setState({
                 photoIndex: this.props.active_view-1,
               })
             }  
             
          />
          )
       
      }

          <map name="map-big">
              <area onClick={() => this.props.loadDefault(1)} alt="1" shape="rect" coords="10, 19, 254, 230" />
              <area onClick={() => this.props.loadDefault(2)} alt="2" shape="rect" coords="263, 62, 474, 185" />
              <area onClick={() => this.props.loadDefault(3)} alt="3" shape="rect" coords="43, 247, 222, 464" />
              <area onClick={() => this.props.loadDefault(4)} alt="4" shape="rect" coords="244, 308, 495, 410" />
          </map>
          
          <map name="map-medium">
              <area onClick={() => this.props.loadDefault(1)} alt="1" shape="rect" coords="3, 3, 186, 183" />
              <area onClick={() => this.props.loadDefault(2)} alt="2" shape="rect" coords="189, 3, 356, 183" />
              <area onClick={() => this.props.loadDefault(3)} alt="3" shape="rect" coords="3, 186, 163, 337" />
              <area onClick={() => this.props.loadDefault(4)} alt="4" shape="rect" coords="166, 186, 356, 337" />
          </map>
          
          <map name="map-small">
              <area onClick={() => this.props.loadDefault(1)} alt="1" shape="rect" coords="1, 1, 101, 96" />
              <area onClick={() => this.props.loadDefault(2)} alt="2" shape="rect" coords="104, 1, 199, 96" />
              <area onClick={() => this.props.loadDefault(3)} alt="3" shape="rect" coords="1, 98, 89, 188" />
              <area onClick={() => this.props.loadDefault(4)} alt="4" shape="rect" coords="92, 97, 199, 188" />
          </map>

          {/* <map name="map-small">
              <area onClick={() => this.props.loadDefault(1)} alt="1" shape="rect" coords="1, 1, 127, 120" />
              <area onClick={() => this.props.loadDefault(2)} alt="2" shape="rect" coords="1, 123, 112, 235" />
              <area onClick={() => this.props.loadDefault(3)} alt="3" shape="rect" coords="130, 1, 249, 120" />
              <area onClick={() => this.props.loadDefault(4)} alt="4" shape="rect" coords="115, 122, 249, 235" />
          </map> */}

          {/* rect
              <map name="map500">
              <area onClick={() => this.props.loadDefault(1)} alt="1" shape="rect" coords="6, 6, 259, 238" />
              <area onClick={() => this.props.loadDefault(2)} alt="2" shape="rect" coords="6, 241, 233, 467" />
              <area onClick={() => this.props.loadDefault(3)} alt="3" shape="rect" coords="262, 6, 494, 238" />
              <area onClick={() => this.props.loadDefault(4)} alt="4" shape="rect" coords="236, 241, 494, 467" />
          </map>
          
          <map name="map250">
              <area onClick={() => this.props.loadDefault(1)} alt="1" shape="rect" coords="1, 1, 127, 120" />
              <area onClick={() => this.props.loadDefault(2)} alt="2" shape="rect" coords="1, 123, 112, 235" />
              <area onClick={() => this.props.loadDefault(3)} alt="3" shape="rect" coords="130, 1, 249, 120" />
              <area onClick={() => this.props.loadDefault(4)} alt="4" shape="rect" coords="115, 122, 249, 235" />
          </map> */}

          {/* href
              <map name="map500">
              <area href="#" alt="1" shape="rect" coords="6, 6, 259, 238" />
              <area href="#" alt="2" shape="rect" coords="6, 241, 233, 467" />
              <area href="#" alt="3" shape="rect" coords="262, 6, 494, 238" />
              <area href="#" alt="4" shape="rect" coords="236, 241, 494, 467" />
          </map>
          
          <map name="map250">
              <area href="#" alt="1" shape="rect" coords="1, 1, 127, 120" />
              <area href="#" alt="2" shape="rect" coords="1, 123, 112, 235" />
              <area href="#" alt="3" shape="rect" coords="130, 1, 249, 120" />
              <area href="#" alt="4" shape="rect" coords="115, 122, 249, 235" />
          </map> */}
        </div>
    );
  }
}
export default AiImageBig;


// WEBPACK FOOTER //
// ./src/layout/AiImageBig.js